var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8712 10.1982H15.1339C14.5975 10.1982 14.1626 10.6331 14.1626 11.1695V48.8356C14.1626 49.372 14.5975 49.8067 15.1339 49.8067H44.8712C45.4076 49.8067 45.8425 49.372 45.8425 48.8356V11.1695C45.8425 10.6331 45.4076 10.1982 44.8712 10.1982Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8659 11.1691V48.8303H15.1335V11.1691H44.8659ZM44.8659 9.22168H15.1335C14.617 9.22168 14.1217 9.42686 13.7565 9.79208C13.3912 10.1573 13.186 10.6526 13.186 11.1691V48.8303C13.186 49.3467 13.3912 49.8421 13.7565 50.2072C14.1217 50.5725 14.617 50.7777 15.1335 50.7777H44.8659C45.1216 50.7777 45.375 50.7273 45.6112 50.6294C45.8475 50.5316 46.0622 50.3881 46.243 50.2072C46.4239 50.0264 46.5673 49.8117 46.6652 49.5755C46.763 49.3392 46.8134 49.086 46.8134 48.8303V11.1691C46.8134 10.9134 46.763 10.6602 46.6652 10.4239C46.5673 10.1876 46.4239 9.97292 46.243 9.79208C46.0622 9.61124 45.8475 9.46779 45.6112 9.36992C45.375 9.27206 45.1216 9.22168 44.8659 9.22168Z",
    fill: "#FE6338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 47.8391H43.8752V20.0889L16.125 47.8391Z",
    fill: "#FE6338"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.5215 15.1338H18.4839V21.1496H41.5215V15.1338Z",
    fill: "#FE6338"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8817 25.7783C26.1554 25.7783 26.3773 26.0002 26.3773 26.2738V44.8665C26.3773 45.1402 26.1554 45.3621 25.8817 45.3621C25.6081 45.3621 25.3862 45.1402 25.3862 44.8665V26.2738C25.3862 26.0002 25.6081 25.7783 25.8817 25.7783Z",
    fill: "#FE6338"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.118 25.7783C34.3918 25.7783 34.6136 26.0002 34.6136 26.2738V44.8665C34.6136 45.1402 34.3918 45.3621 34.118 45.3621C33.8443 45.3621 33.6226 45.1402 33.6226 44.8665V26.2738C33.6226 26.0002 33.8443 25.7783 34.118 25.7783Z",
    fill: "#FE6338"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5215 39.1272C41.5216 39.4008 41.2998 39.6228 41.0262 39.6229L18.9796 39.6329C18.7059 39.633 18.484 39.4112 18.4839 39.1375C18.4838 38.8638 18.7055 38.6419 18.9791 38.6418L41.0258 38.6318C41.2995 38.6317 41.5214 38.8535 41.5215 39.1272Z",
    fill: "#FE6338"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0261 33.1014L18.9795 33.1065C18.7059 33.1065 18.4839 32.8847 18.4839 32.611C18.4838 32.3373 18.7056 32.1154 18.9792 32.1154L41.0259 32.1104C41.2995 32.1104 41.5215 32.3321 41.5215 32.6058C41.5216 32.8796 41.2997 33.1014 41.0261 33.1014Z",
    fill: "#FE6338"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5215 26.0802C41.5216 26.3539 41.2998 26.5759 41.0262 26.576L18.9796 26.5859C18.7059 26.586 18.484 26.3642 18.4839 26.0906C18.4838 25.8169 18.7055 25.5949 18.9791 25.5948L41.0258 25.585C41.2995 25.5848 41.5214 25.8066 41.5215 26.0802Z",
    fill: "#FE6338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrder);
export default __webpack_public_path__ + "static/media/purchase-order.b9170db0200dcb4356575d203189f0c8.svg";
export { ForwardRef as ReactComponent };